import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=0922481b&scoped=true"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"
import style0 from "./cart.vue?vue&type=style&index=0&id=0922481b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922481b",
  null
  
)

export default component.exports